import DataForm from '@/core/work-components/data-form';
import { mixin as pluginMinx } from '@/plugin/index.min.js';
import EmapPlugin from './plugins';
export default {
  name: 'SearchPanel',
  components: {
    DataForm
  },
  mixins: [pluginMinx],
  EmapPlugin,
  props: {
    /**
     * 待搜索的控件定义列表，参考 data-form 控件的 children 格式
     */
    controls: Array,

    /**
     * 收起的时候保留的搜索控件个数
     */
    limit: {
      type: Number,
      default: 2
    },

    /**
     * 查询按钮文本
     */
    queryText: {
      type: String,
      default: '查询'
    },

    /**
     * 重置按钮文本
     */
    resetText: {
      type: String,
      default: '重置'
    },

    /**
     * 更多按钮文本
     */
    expandText: {
      type: String,
      default: '更多'
    },

    /**
     * 收起按钮文本
     */
    collapseText: {
      type: String,
      default: '收起'
    }
  },
  data: () => ({
    value: {},
    isCollapse: false
  }),
  computed: {
    formSchema() {
      const {
        controls = [],
        limit,
        isCollapse
      } = this;
      const formSchema = {
        labelPosition: 'left',
        labelWidth: 80,
        children: isCollapse ? controls.slice(0, limit) : controls
      };
      return this.$applyPluginsWaterfall('format-schema', formSchema) || [];
    },

    hasMore() {
      const {
        controls,
        limit
      } = this;
      return controls && controls.length > limit;
    }

  },
  methods: {
    /**
     * 获取当前设置的搜索条件
     * @vuese
     */
    getValue() {
      return { ...this.value
      };
    },

    doSearch() {
      /**
       * 点击搜索的时候触发此事件，参数为当前设置的搜索条件
       */
      this.$emit('search', { ...this.value
      });
    },

    doReset() {
      this.value = {};
      /**
       * 点击重置的时候触发此事件
       */

      this.$emit('reset');
    },

    /**
     * 切换当前条件收起/展开模式
     * @vuese
     */
    toggleMore() {
      const newVal = !this.isCollapse;
      this.isCollapse = newVal;

      if (newVal) {
        /**
         * 收起搜索条件的时候触发此事件
         */
        this.$emit('collapse');
      } else {
        /**
         * 展开搜索条件的时候触发此事件
         */
        this.$emit('expand');
      }
    }

  }
};